// Адрес карты /tutors с фильтрами (?type=&subject=&district=). Отдельно от
// разбора (map-query.ts), чтобы главная не тянула справочник синхронно:
// здесь нет импорта map-taxonomy.
export type MapLayer = "tutor" | "club";

/** Адрес карты с фильтрами; пустые поля в адрес не попадают. */
export function mapQueryHref(base: string, f: { layer: MapLayer; subject?: string; district?: string; city?: string }): string {
  const q = new URLSearchParams();
  q.set("type", f.layer);
  if (f.subject) q.set("subject", f.subject);
  if (f.district) q.set("district", f.district);
  // Город — только не Баку: Баку у карты и так по умолчанию.
  if (f.city && f.city !== "baku") q.set("city", f.city);
  return `${base}?${q.toString()}`;
}
